var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalpelIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_4388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1572 0.486488C27.0304 0.230902 26.7919 0.0555314 26.5121 0.011176C26.2329 -0.0336481 25.9495 0.0579338 25.7497 0.257621L16.9424 9.01837L21.9145 13.9904L25.5483 10.4033C28.1672 7.78438 28.8142 3.7992 27.1572 0.486488Z",
    fill: "url(#paint0_linear_1231_4388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90616 22.0365L3.17175 22.7709C1.52023 24.4224 1.52023 27.1087 3.17175 28.7602C4.93184 30.5203 7.82601 30.3893 9.42017 28.4768L9.84117 27.9716L3.90616 22.0365Z",
    fill: "url(#paint1_linear_1231_4388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 14.72L16.9423 13.9904L18.1853 12.7474L15.6993 10.2614L11.9702 13.9904L17.1143 19.1345L17.8327 18.2723C18.7116 17.2176 18.6423 15.6905 17.6719 14.72Z",
    fill: "url(#paint2_linear_1231_4388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.727 15.2334L5.14893 20.7933L10.971 26.6155L15.9841 20.4904L10.727 15.2334Z",
    fill: "url(#paint3_linear_1231_4388)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1231_4388",
    x1: 17.0977,
    y1: 11.1924,
    x2: 28.067,
    y2: 11.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1231_4388",
    x1: 2.0435,
    y1: 28.4074,
    x2: 9.84117,
    y2: 28.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1231_4388",
    x1: 12.0606,
    y1: 17.3599,
    x2: 18.4485,
    y2: 17.3599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1231_4388",
    x1: 5.30018,
    y1: 24.3391,
    x2: 15.9841,
    y2: 24.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_4388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalpelIc);
export default __webpack_public_path__ + "static/media/scalpel_ic.eece234857afe010a3c1849698ae4896.svg";
export { ForwardRef as ReactComponent };